import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row items-center" }
const _hoisted_2 = { class: "secondary" }
const _hoisted_3 = { class: "row items-center" }

import { storeToRefs } from 'pinia';
    import { ref, Ref, watch } from 'vue';
    import { useGrouperStore } from 'stores/grouper-store';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'DualPane',
  props: {
    horizontal: { type: Boolean },
    vertical: { type: Boolean },
    disable: { type: Boolean },
    beforeClass: {},
    afterClass: {},
    separatorClass: {},
    expanded: { type: Boolean },
    secondaryVisible: { type: Boolean },
    dark: { type: Boolean }
  },
  emits: ["secondary-expanded"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emit = __emit

    const expanded: Ref<boolean> = ref(props.expanded)

    const grouperStoreRef = storeToRefs(useGrouperStore());

    watch(grouperStoreRef.drgDrawerState, (updated) => {
      expanded.value = updated;
    });

    const onButtonClicked = () => {
      expanded.value = !expanded.value;
       emit('secondary-expanded', expanded.value)
        return expanded.value;
    };


return (_ctx: any,_cache: any) => {
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_slide_transition = _resolveComponent("q-slide-transition")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_card, {
      "text-none": "",
      class: _normalizeClass(["iodine-padding-md iodine-dual-pane-primary iodine-drg-card", _ctx.beforeClass])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "primary")
        ])
      ]),
      _: 3
    }, 8, ["class"]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["secondary__icon", {'secondary__icon--active': expanded.value}]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onButtonClicked()))
      }, [
        _createVNode(_component_q_icon, {
          name: "fa-solid fa-chevron-down",
          size: "12px"
        })
      ], 2),
      _createVNode(_component_q_slide_transition, { appear: "" }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_q_card, {
            "text-none": "",
            class: _normalizeClass(["iodine-padding-md iodine-dual-pane-secondary iodine-drg-card", _ctx.afterClass])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "secondary")
              ])
            ]),
            _: 3
          }, 8, ["class"]), [
            [_vShow, expanded.value]
          ])
        ]),
        _: 3
      })
    ], 512), [
      [_vShow, _ctx.secondaryVisible]
    ])
  ], 64))
}
}

})